import { render, staticRenderFns } from "./StockConfig.vue?vue&type=template&id=14742acb&"
import script from "./StockConfig.vue?vue&type=script&lang=js&"
export * from "./StockConfig.vue?vue&type=script&lang=js&"
import style0 from "./StockConfig.vue?vue&type=style&index=0&id=14742acb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports